import { Box, Timeline as CoreTimeline } from '@hopskipdrive/react-components';
import { colorPalette, colorTokens, variables } from '@rideiq/shared/components/variables';
import styled from 'styled-components';

export const TimelineGrid = styled.div`
  display: grid;
  grid-template-areas: 'side content';
  grid-template-columns: 1fr 4fr;

  @media (max-width: 400px) {
    display: block;

    [data-testid='time-anchor-toggle'] {
      position: absolute;

      button {
        padding: 10px;
      }
    }
  }
`;

export const Timeline = styled(CoreTimeline)`
  .MuiTimelineItem-root {
    display: grid;
    grid-template-areas: 'side content';
    grid-template-columns: 1fr 4fr;
    padding: 0;

    ${variables.mediaQuery.lessThan('desktop')`   
     .MuiTimelineContent-root {
      padding-top: 6px;
    }
  `}

    @media (max-width: 400px) {
      margin-top: 30px;
    }
  }
`;

export const RiderContainer = styled(Box)<{ $highlight }>`
  border: ${({ $highlight }) => ($highlight ? `3px solid ${colorPalette.yellow60}` : 'none')};
  border-radius: 20px;
`;

export const RiderAssistantTimelineItem = styled(CoreTimeline.Item)`
  background-color: #eafcf3;
  margin: -20px -30px;
  margin-bottom: 20px;
  padding: 20px 30px !important;
  padding-bottom: 20px !important;

  .MuiTimelineConnector-root {
    margin-bottom: -40px;
  }

  .MuiTimelineSeparator-root {
    svg {
      color: ${colorPalette.green70} !important;
    }
  }

  &:last-child {
    .MuiTimelineConnector-root {
      margin-bottom: 0px;
      margin-top: -70px;
    }

    .MuiTimelineSeparator-root {
      & > div {
        z-index: 2;
      }

      & > div > div > div {
        background-color: ${colorPalette.green70} !important;
        border-color: ${colorPalette.green70};
      }
    }
  }
`;

export const RiderAssistant = styled(Box)`
  margin-bottom: 16px;
  border-radius: 20px;
  box-shadow: 0px 4px 10px rgba(29, 75, 122, 0.1);
  padding: 5px;
  background-color: ${colorPalette.neutral99};
  font-weight: 500;
  color: ${colorTokens.text.medium};
  display: flex;
  align-items: center;

  span {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    background-color: ${colorPalette.green70};
    color: ${colorPalette.neutral99};
  }

  div {
    margin-left: 10px;
  }
`;
